import React from 'react';
import 'slickjs';
import 'animatednumber';
import MediaViewer from '../shared/ui/components/MediaViewer';
//import startBook from '../booking/index';
//import startFollowup from '../followup/index';
import startNewsletter from '../newsletter/index';
import startOptimallesList from '../optimalle/index';
import isUndefined from 'lodash/isUndefined';
import i18n from '../i18n';
import moment from "moment";

function animateCounters() {
    $(window).off('scroll', trackScrollForAnimatedCounters);
    jQuery('.animated-value').each(function() {
        const $value = $(this);
        $(this).animateNumber({
            number: $value.data('value'),
            easing: 'easeInQuad'
        },
        1000);
    });
}

function changeLocale(locale){
    moment.locale(locale);
    i18n.changeLanguage(locale);
}

function trackScrollForAnimatedCounters() {
    const counters = $('#counters');
    let offset = $('#counters').offset();
    if (isUndefined(counters) || !counters || isUndefined(offset)) {
        return;
    }

    const oTop = offset.top - window.innerHeight;
    const pTop = $('body').scrollTop();
    if( pTop > oTop ){
        animateCounters();
    }
}

export function handle_homepage(params) {
    changeLocale(params.locale);
    startNewsletter();
    jQuery(document).ready(function() {
        jQuery('#slider > .item').css('visibility', 'visible');

        jQuery('#slider').slick({
            dots: true,
            infinite: false,
            speed: 600,
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            cssEase: 'linear',
            draggable: false
        });

        $(window).on('scroll', trackScrollForAnimatedCounters);
    });
}

export function handle_single_hike(params) {
    changeLocale(params.locale);
    startNewsletter();
    jQuery(document).ready(function() {
        const galleryNode = document.getElementById('gallery');
        const photoswipeNode = document.getElementById('photoswipe');

        if (null == galleryNode || null == galleryNode) {
            return;
        }

        const gallery = new MediaViewer(galleryNode, photoswipeNode);

        jQuery('.hikes-slick').slick({
            dots: false,
            infinite: true,
            speed: 400,
            autoplay: false,
            draggable: false,
            variableWidth: true,
            slidesToShow: 3
        });


        jQuery('.services-slick').slick({
            dots: false,
            infinite: true,
            speed: 400,
            autoplay: false,
            draggable: false,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

    });
}


// export function handle_book(params) {
//     changeLocale(params.locale);
//     startBook();
// // }
//
// export function handle_book_service(params) {
//     changeLocale(params.locale);
//     startBook();
// }

export function handle_optimalles_list(params) {
    changeLocale(params.locale);
    startOptimallesList(params);
}

export function handle_optimalles_list_by_theme(params) {
    changeLocale(params.locale);
    startOptimallesList(params);
}

export function handle_optimalles_list_by_theme_and_hike(params) {
    changeLocale(params.locale);
    startOptimallesList(params);
}
//
// export function handle_book_service_next(params) {
//     changeLocale(params.locale);
//     startBook();
// }
//
// export function handle_customer_reservation(params) {
//     changeLocale(params.locale);
//     startFollowup(params);
// };

export function handle_default(params) {
    changeLocale(params.locale);
    startNewsletter();
}
